import Vue, { i18n, VueI18n } from '/vodalys/vvuejs/vue'


import { camelToKebab, camelToSnake } from './utils.mjs'
import { vuejsComponents } from './vueRegister.mjs'

export const vWrapperModule = angular.module('vvuejs.vconsole.vWrapper', [])

// Pas sûr que ça serve désormais mais dans le doute...
if(Vue.config.ignoredElements)
{
    Vue.config.ignoredElements.push('ng-transclude');
}
else
{
    Vue.config.ignoredElements = ['ng-transclude'];
}

vWrapperModule.component('vWrapper', {
    controller: class VWrapperController {
        constructor($scope, $element, $injector, $timeout, $attrs) {

            this.ngContext = () => {

                return {
                    $injector,
                    $scope,
                    $element,
                    $attrs
                }
            }
            

            queueMicrotask(async _ => {

                if($element.find('> *').length > 1)
                {
                    console.error('<v-wrapper> component can have only one child.', $scope);
                }

                const child = $element.find('> *')

                this.vueApp = new Vue({
                    i18n,
                    name: this.name || 'vWrapperApp',
                    el: child[0],
                    components: this.vueComponents,
                    data: {
                        component: this.component,
                        instance: this.instance,
                        handler: this.handler,
                        ngContext: this.ngContext
                    },
                    mounted() {
                    },
                    watch: {
                        instance(instance) {
                            $timeout(() => 'ng digest')
                        }
                    }
                })
            })


            $scope.$on('$destroy', () => {
                if (this.vueApp) {
                    this.vueApp.$destroy();
                }
            });

        }
    },
    bindings: {
        component: '=',
        handler: '=',
        instance: '=',
        vueComponents: '=',
        name: '@'
    },
})

vWrapperModule.directive('vuejs', function () {
    return {
        priority: 100,
        restrict: 'E',
        scope: true,
        link: function ($scope, $element, $attr) {

            let data = {
                Vue: Vue,
                ngContext: () => {

                    return {
                        $scope,
                        $element,
                        $attrs: $attr
                    }
                }
            }
            let methods = {}
            let watch = {}

            var attrsToOmit = ['elementName', '$attr', 'ngRepeat', 'ngIf'];
            angular.forEach($attr.$attr, function (value, key) {
                if ($attr.hasOwnProperty(key) && (attrsToOmit.indexOf(key) < 0) && (key.indexOf('$$') !== 0)) {
                    if (key.startsWith('vuejsModel')) {
                        const realKey = value.split(':')[1]

                        const valuePath = $element.attr(value);

                        const getter = $scope.parse(valuePath);

                        data[realKey] = getter($scope);

                        $scope.$watch(valuePath, (val) => data[realKey] = val);

                        //TODO Probleme si la modif vient de l'exterieur, alors y'a un digest fait pour rien... 
                        // => $set ?
                        watch[realKey] =
                        {
                            handler: (v) => $scope.$digest(),
                            deep: true
                        }
                    }
                    else if (key.startsWith('vuejsOn')) {
                        const realKey = value.split(':')[1]

                        const valuePath = $element.attr(value);

                        const getter = $scope.parse(valuePath);

                        methods[realKey] = function (args) {
                            getter($scope, args);
                            setTimeout(() => $scope.$digest())
                        }
                    }
                    else if (key.startsWith('vuejsAttr')) {
                        const realKey = value.split(':')[1]

                        data[realKey] = null;

                        data[realKey] = $element.attr(value)

                        $attr.$observe(key, function (newValue) {
                            data[realKey] = newValue;
                        })
                    }
                }
            });

            if (process.env.NODE_ENV !== 'production') {
                // Only runs in development and will be stripped in production builds.
                if (!$element.attr('name')) {
                    console.error('please name your unamed vuejsapp', $element[0])
                }
                else if ($element.attr('name') === 'vuejsApp') {
                    console.error('please rename your vuejsapp', `"${$element.attr('name')}"`, $element[0])
                }
            }

            if($element.find('> *').length > 1)
            {
                console.error('<vuejs> directive can have only one child.', $scope);
            }

            $scope.vueApp = new Vue({
                i18n,
                name: $element.attr('name') || 'vuejsApp',
                el: $element.find('> *')[0],
                components: vuejsComponents,
                data,
                methods,
                watch
            });

            $scope.$on('$destroy', function () {
                $scope.vueApp.$destroy();
            });
        },
        controller: function ($scope, $parse) {
            $scope.parse = $parse;
        }
    }
});